<template>
  <b-row>
    <b-col cols="12">
      <!-- Loading indicator -->
      <b-row v-if="loading" class="py-3">
        <b-col cols="12" class="text-center">
          <b-spinner small variant="primary"></b-spinner>
          <span class="ml-2 text-xs text-gray">Loading beneficial owners...</span>
        </b-col>
      </b-row>

      <!-- Empty state -->
      <b-row v-else-if="persons.length === 0" class="py-3">
        <b-col cols="12" class="text-center">
          <span class="text-xs text-gray">No beneficial owners found.</span>
        </b-col>
      </b-row>

      <!-- List of persons -->
      <b-row v-else class="mx-1 py-1" v-for="(person, idx) in persons" :key="idx">
        <b-col cols="12">
          <b-row class="py-1 border-b border-gray">
            <b-col cols="6">
              <span class="text-xs font-bold text-capitalize">
                {{ person.givenName }} {{ person.middleName }} {{ person.surName }}
              </span>
            </b-col>
            <b-col cols="4" v-if="person.parentBrn">
              <span class="text-xs font-bold text-capitalize mr-2">Parent:</span>
              <span class="text-xs font-bold text-capitalize">{{ person.parentBrn }}</span>
              <span class="text-xs font-bold text-capitalize ml-1">{{ person.parentName }}</span>
            </b-col>
            <b-col :cols="person.parentBrn ? 2 : 6">
              <button class="bg-blue text-white rounded-sm px-2 py-1 text-xs float-end" @click="show(idx)">
                <span v-if="selectedIdx === idx">Hide Details</span>
                <span v-else>Show Details</span>
              </button>
            </b-col>
          </b-row>
          <b-row v-if="showDetails && selectedIdx === idx">
            <b-col cols="12">
              <b-row>
                <b-col cols="4">
                  <b-form-group
                    class="text-sm my-1"
                    label="Given Name">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="person.givenName"
                      required>
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="person.middleName"
                    class="text-sm my-1"
                    label="Middle Name">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="person.middleName"
                      required>
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="text-sm my-1"
                    label="Surname">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="person.surName"
                      required>
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="person.idType"
                    class="text-sm my-1"
                    label="ID Type">
                    <b-form-input
                      class="form-text text-sm noFocus text-capitalize"
                      type="text"
                      disabled="true"
                      :value="person.idType.toLowerCase()"
                      required>
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="text-sm my-1"
                    label="ID Number">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="person.idNumber"
                      required>
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="text-sm my-1"
                    label="Nationality">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="person.nationality"
                      required>
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="4">
                  <b-form-group
                    class="text-sm my-1"
                    label="Email Address">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="person.email"
                      required>
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="text-sm my-1"
                    label="Phone Number">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="person.phoneNumber"
                      required>
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="person.sex"
                    class="text-sm my-1"
                    label="Gender (at birth)">
                    <b-form-input
                      class="form-text text-sm noFocus text-capitalize"
                      type="text"
                      disabled="true"
                      :value="person.sex.toLowerCase()"
                      required>
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="text-sm my-1"
                    label="Date of Birth">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="dateFormat(person.dateOfBirth)"
                      required>
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="text-sm my-1"
                    label="Occupation">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="person.occupation"
                      required>
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="4" v-if="person.village">
                  <b-form-group
                    class="text-sm my-1"
                    label="District">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="person.village.district ? person.village.district.name : ''"
                      required>
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="text-sm my-1"
                    label="Region">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="person.village.region ? person.village.region.name : ''"
                      required>
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="text-sm my-1"
                    label="Sub county">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="person.village.subcounty ? person.village.subcounty.name : ''"
                      required>
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="text-sm my-1"
                    label="Parish">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="person.village.parish ? person.village.parish.name : ''"
                      required>
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="text-sm my-1"
                    label="Village">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="person.village.village ? person.village.village.name : ''"
                      required>
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="4" v-else-if="person.foreignPhysicalAddress">
                  <b-form-group
                    class="text-sm my-1"
                    label="Address (Foreign)">
                    <b-form-textarea
                      class="form-text text-sm noFocus"
                      disabled="true"
                      rows="3"
                      :value="person.foreignPhysicalAddress"
                      required>
                    </b-form-textarea>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col cols="4">
                  <b-form-group
                    class="text-sm my-1"
                    label="Postal Address">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="person.postalAddress"
                      required>
                    </b-form-input>
                    <PostalAddressValidator v-if="person.postalAddress" :box-number="person.postalAddress"/>
                  </b-form-group>
                  <b-form-group
                    class="text-sm my-1"
                    label="Street">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="person.street"
                      required>
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="text-sm my-1"
                    label="Plot">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="person.plot"
                      required>
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="4">
                  <b-form-group
                    v-if="person.parentBrn"
                    class="text-sm my-1"
                    label="Parent Brn">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled
                      :value="person.parentBrn"
                      required>
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="text-sm my-1"
                    label="Shares/Control">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled
                      :value="person.percentageShares"
                      required>
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="text-sm my-1"
                    label="Percentage Voting Rights">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled
                      :value="person.percentageVotingRights"
                      required>
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="4">
                  <b-form-group
                    class="text-sm my-1"
                    label="Has Voting Rights">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled
                      :value="person.hasVotingRights"
                      required>
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="text-sm my-1"
                    label="Has Right To Appoint">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled
                      :value="person.hasRightToAppoint"
                      required>
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="person.amountGuaranteed"
                    class="text-sm my-1"
                    label="Amount Guaranteed">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled
                      :value="person.amountGuaranteed"
                      required>
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import moment from "moment";
import { api } from "@/app/services/api.service";
import PostalAddressValidator from "@/views/home/commons/PostalAddressValidator";

export default {
  name: "BeneficialOwnersV2",
  components: { PostalAddressValidator },
  props: {
    trackingNumber: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      persons: [],
      loading: false,
      showDetails: false,
      selectedIdx: null
    };
  },
  watch: {
    trackingNumber: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.fetchBeneficialOwners(newVal);
        }
      }
    }
  },
  methods: {
    async fetchBeneficialOwners(trackingNo) {
      this.loading = true;
      try {
        const response = await api().get(
          `/bo/forms/${trackingNo}/end-beneficial-owners?children=true`
        );
        const boOwners = response.data?.data?.beneficialOwners || [];
        this.persons = boOwners.map(owner => {
          const ind = owner.individual || {};
          const nc = owner.natureOfControl || {};
          return {
            givenName: ind.givenName || "",
            middleName: ind.middleName || "",
            surName: ind.surName || "",
            idType: ind.idType || "Passport",
            idNumber: ind.idNumber || "",
            nationality: ind.nationality || (ind.country ? ind.country.name : ""),
            email: ind.email || "",
            phoneNumber: ind.phoneNumber || "",
            sex: ind.sex || "",
            dateOfBirth: ind.dateOfBirth || "",
            occupation: ind.occupation || "",
            village: ind.village || null,
            foreignPhysicalAddress: ind.foreignPhysicalAddress || "",
            postalAddress: ind.postalAddress || ind.foreignPostalAddress || "",
            street: ind.street || "",
            plot: ind.plot || "",
            parentBrn: owner.parentBrn || "",
            parentName: owner.parentName || "",
            percentageShares: this.formatNatureOfControl(nc),
            percentageVotingRights: nc.percentageVotingRights || "",
            hasVotingRights: nc.hasVotingRights || "",
            hasRightToAppoint: nc.hasRightToAppoint || "",
            amountGuaranteed: nc.amountGuaranteed ? `UGX ${nc.amountGuaranteed.toLocaleString()}` : ""
          };
        });
      } catch (error) {
        console.error("Failed to fetch beneficial owners:", error);
      } finally {
        this.loading = false;
      }
    },
    formatNatureOfControl(nc) {
      let nature = "";
      if (!nc) return nature;
      if (nc.percentageShares != null && Number(nc.percentageShares) > 0) {
        nature += nc.percentageShares + "%";
      }
      return nature;
    },
    dateFormat(date) {
      if (!date) return "";
      return moment(date).format("DD/MM/YYYY");
    },
    show(idx) {
      if (this.selectedIdx === idx) {
        this.selectedIdx = null;
        this.showDetails = false;
      } else {
        this.selectedIdx = idx;
        this.showDetails = true;
      }
    }
  }
};
</script>

<style scoped>

</style>
